import * as PinValidationReducer from './pin-validation.reducer';

import * as MetaReducers from './pin-validation.metareducer';

export const PinValidationReducers = { PinValidationReducer, MetaReducers };
